import { apiAddress } from "../../config/server";
import { IComment } from "../../types/comments/Comment";
import { ITeam } from "../../types/team/Team";
import { ApiBase } from "./baseApi";

export default class TeamApi extends ApiBase {
  static TeamApiAddress = `${apiAddress}/api/team/`;

  static GetAllTeams = TeamApi.TeamApiAddress;

  static GetById = TeamApi.TeamApiAddress;

  static getAllTeams(): Promise<ITeam[]> {
    return this.get(this.GetAllTeams).then((resp) => resp.data.teams || []);
  }

  static getTeamById(teamId: string): Promise<ITeam> {
    return this.get(this.TeamApiAddress + teamId).then(
      (resp) => resp.data.teams?.[0] as ITeam,
    );
  }

  static updateTeam(team: Partial<ITeam>) {
    if (!team._id) throw new Error("Need team._id to update team");

    return this.post(this.TeamApiAddress + team._id, team).then(
      (resp) => resp.data.teams?.[0] as ITeam,
    );
  }

  static getCommentsByTeamId(teamId: string): Promise<IComment[]> {
    return this.get<IComment[]>(`${this.TeamApiAddress + teamId}/comment`).then(
      (resp) => resp.data.data,
    );
  }

  static postCommentToTeam(
    teamId: string,
    content: string,
  ): Promise<IComment[]> {
    return this.post<IComment[]>(`${this.TeamApiAddress + teamId}/comment`, {
      content,
    } as IComment).then((resp) => resp.data.data);
  }
}
